<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('edit') }} {{ $t('batchContactsList.batchContactsList') }}
                <template v-if="isLoaded && batchContactsList.name"> - {{ batchContactsList.name }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        v-if="batchContactsList.name"
                        :to="{
                            name: 'lists.batchContacts.show',
                            params: { id: batchContactsListId },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('batchContactsList.backToBatchContactsList') }}</span>
                        <span class="hidden-xs">{{ $t('batchContactsList.backToBatchContactsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-arrow-left"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'lists.batchContacts.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('batchContactsList.batchContactsLists') }}</span>
                        <span class="hidden-xs">{{ $t('batchContactsList.batchContactsLists') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <ListsBatchContactsForm
                            v-show="isLoaded"
                            :batchContactsListId="batchContactsListId"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ListsBatchContactsForm from '@/components/lists/batch-contacts/ListsBatchContactsForm';

export default {
    components: {
        ListsBatchContactsForm,
    },

    data() {
        return {
            isLoaded: false,
            batchContactsListId: Number(this.$route.params.id),
            batchContactsList: {},
        };
    },

    computed: {
        headTitle() {
            return (
                this.batchContactsList.name &&
                `${this.$t('batchContactsList.batchContactsList')} ${this.batchContactsList.name} ${this.$t('edit')}`
            );
        },
    },

    methods: {
        onLoaded(batchContactsList) {
            this.batchContactsList = batchContactsList;
            this.isLoaded = true;
        },
    },
};
</script>
